
function requestAPI() {
  return fetch(`${process.env.REACT_APP_BASE_URL}banner-sgh`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((res) => res.json())
}

export default function actionListBanner() {
  return async (dispatch) => {
    dispatch({
      type: 'LIST_BANNER_BEGIN'
    })

    try {
      const result = await requestAPI()
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'LIST_BANNER_SUCCESS',
        payload: result.data
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'LIST_BANNER_FAILURE',        
    error: error    
  })
}